import { type ArtworkFile, type VirtualDesignFont, type VirtualDesignImage, type VirtualDesignLogo } from '../types'

export type LastCartItemImprint = {
  Location: string
  Method: string
  IsVirtualDesign:boolean
  ArtworkFiles: ArtworkFile[]
  VirtualDesignArts: ArtworkFile[]
  VirtualDesignFonts: VirtualDesignFont[]
  VirtualDesignImage: VirtualDesignImage
  VirtualDesignLogo: VirtualDesignLogo[]
  VirtualDesignJson:string
  ImprintColor: string[]
  ArtworkText:string
  ArtworkOption: number
}

export type LastCartItem = {
  PreviousImage: string
  ImprintOptions: LastCartItemImprint[]
  ProductOptions: Record<string, string>[]
}

export const useLastCart = (): LastCartItem | undefined => {
  // 先从JSON数据里加载用户信息
  const lastCartData: LastCartItem = (window as any).lastCartData
  if (!lastCartData) {
    return undefined
  }

  return {
    PreviousImage: lastCartData.PreviousImage,
    ProductOptions: lastCartData.ProductOptions,
    ImprintOptions: lastCartData.ImprintOptions
  }
}
